<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1" id="d7e215"><b>A<span class="small">LSO IN THE</span> A<span class="small">KASHIC</span> N<span class="small">OIR</span> S<span class="small">ERIES</span>:</b></p>
<p class="ded" id="d7e425"><b><i>D.C. Noir</i></b>, edited by George Pelecanos</p>
<p class="ded" id="d7e495"><b><i>Brooklyn Noir</i></b>, edited by Tim McLoughlin</p>
<p class="ded" id="d7e565"><b><i>Brooklyn Noir 2: The Classics,</i></b>edited by Tim McLoughlin</p>
<p class="ded" id="d7e635"><b><i>Chicago Noir,</i></b>edited by Neal Pollack</p>
<p class="ded" id="d7e715"><b><i>San Francisco Noir</i></b>, edited by Peter Maravelis<br/>
<br/>
<br/></p>
<p class="ded1" id="d7e785"><b>F<span class="small">ORTHCOMING:</span></b></p>
<p class="ded" id="d7e875"><b><i>Manhattan Noir</i></b>, edited by Lawrence Block</p>
<p class="ded" id="d7e945"><b><i>Baltimore Noir,</i></b>edited by Laura Lippman</p>
<p class="ded" id="d7e1015"><b><i>Twin Cities Noir</i></b>, edited by Julie Schaper &amp; Steven Horwitz</p>
<p class="ded" id="d7e1085"><b><i>Los Angeles Noir,</i></b>edited by Denise Hamilton</p>
<p class="ded" id="d7e1165"><b><i>London Noir,</i></b>edited by Cathi Unsworth</p>
<p class="ded" id="d7e1235"><b><i>Havana Noir</i></b>, edited by Achy Obejas</p>
<p class="ded" id="d7e1305"><b><i>Wall Street Noir</i></b>, edited by Peter Spiegelman</p>
<p class="ded" id="d7e1375"><b><i>Miami Noir</i></b>, edited by Les Standiford</p>
<p class="ded" id="d7e1445"><b><i>Bronx Noir</i></b>, edited by S.J. Rozan</p>
<p class="ded" id="d7e1515"><b><i>Lone Star Noir</i></b>, edited by Edward Nawotka</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brue_ISBN9781936070282_epub_ded3_r1.vue?6c6a2c6c